import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeriodicFormComponent } from './periodic-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDropdownModule } from "../../../shared/components/custom-dropdown/custom-dropdown.module";
import { CustomInputModule } from "../../../shared/components/custom-input/custom-input.module";
import { CustomRadioButtonModule } from "../../../shared/components/custom-radio-button/custom-radio-button.module";
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PeriodicFormRoutingModule } from './periodic-form-routing.module';



@NgModule({
  declarations: [
    PeriodicFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    CustomInputModule,
    CustomRadioButtonModule,
    MaterialModule,
    PeriodicFormRoutingModule
],
  exports:[
    PeriodicFormComponent
  ]
})
export class PeriodicFormModule { }
